import React from 'react';

const SvgJe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="JE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path
        d="M.667 3.833V2.674c0-.74.59-1.34 1.332-1.34h1.336c.735 0 1.332.587 1.332 1.34v1.16c0 1.785-2 2.5-2 2.5s-2-.715-2-2.5z"
        id="JE_svg__c"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="JE_svg__b" fill="#fff">
        <use xlinkHref="#JE_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#E3243B"
        mask="url(#JE_svg__b)"
        transform="rotate(-55 14.659 10.473)"
        d="M13.326-14.193h2.667V35.14h-2.667z"
      />
      <path
        fill="#E3243B"
        mask="url(#JE_svg__b)"
        transform="scale(-1 1) rotate(-55 0 38.633)"
        d="M13.326-14.193h2.667V35.14h-2.667z"
      />
      <g mask="url(#JE_svg__b)">
        <g transform="translate(12 1.333)">
          <path
            d="M1.593 1.333l.087-.05-.987-.57 1.276.142L1.789 0l.878.712L3.544 0l-.18.855L4.64.712l-.987.57.088.051H1.593z"
            fill="#FAEF32"
          />
          <mask id="JE_svg__d" fill="#fff">
            <use xlinkHref="#JE_svg__c" />
          </mask>
          <use fill="#E3243B" xlinkHref="#JE_svg__c" />
          <rect
            fill="#FAEF32"
            mask="url(#JE_svg__d)"
            x={2.333}
            y={5.333}
            width={1}
            height={1}
            rx={0.5}
          />
          <rect
            fill="#FAEF32"
            mask="url(#JE_svg__d)"
            x={1.333}
            y={4}
            width={2.667}
            height={1}
            rx={0.5}
          />
          <rect
            fill="#FAEF32"
            mask="url(#JE_svg__d)"
            x={1.333}
            y={2.667}
            width={2.667}
            height={1}
            rx={0.5}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgJe;
